import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetSingleProjectQuery } from "../../features/Projects/projectApi";
import { useAddTaskMutation } from "../../features/Task/taskApi";
import { useGetSingleTeamMemberQuery } from "../../features/Team/teamApi";

const initialState = {
  taskName: "",
  teamMember: null,
  projectName: null,
  deadline: null,
};

export default function TaskForm() {
  const navigate = useNavigate();
  const [formState, setFormState] = useState(initialState);
  const [addTask, { isSuccess: isAddTaskSuccess }] = useAddTaskMutation();
  const { data: singleTeamMember, isSuccess: isSingleTeamSuccess } =
    useGetSingleTeamMemberQuery(formState.teamMember, {
      skip: !formState.teamMember,
    });
  const { data: singleProject, isSuccess: isSingleProjectSuccess } =
    useGetSingleProjectQuery(formState.projectName, {
      skip: !formState.projectName,
    });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState({ ...formState, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSingleTeamSuccess && isSingleProjectSuccess) {
      const payload = {
        taskName: formState.taskName,
        deadline: formState.deadline,
        teamMember: singleTeamMember[0],
        project: singleProject[0],
      };

      addTask(payload);
    } else {
      alert("Please select a team member and a project");
    }
  };

  useEffect(() => {
    if (isAddTaskSuccess) {
      setFormState(initialState);
      navigate("/");
    }
  }, [isAddTaskSuccess, navigate]);

  return (
    <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
      <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
        Create Task for Your Team
      </h1>
      <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="fieldContainer">
            <label htmlFor="lws-taskName">Task Name</label>
            <input
              type="text"
              name="taskName"
              id="lws-taskName"
              onChange={handleChange}
              value={formState.taskName}
              required
              placeholder="Implement RTK Query"
            />
          </div>
          <div className="fieldContainer">
            <label>Assign To</label>
            <select
              name="teamMember"
              id="lws-teamMember"
              required
              onChange={handleChange}
              value={formState.teamMember}
            >
              <option value hidden selected>
                Select Job
              </option>
              <option>Sumit Saha</option>
              <option>Saad Hasan</option>
              <option>Akash Ahmed</option>
              <option>Md Salahuddin</option>
              <option>Riyadh Hassan</option>
              <option>Ferdous Hassan</option>
              <option>Arif Almas</option>
            </select>
          </div>
          <div className="fieldContainer">
            <label htmlFor="lws-projectName">Project Name</label>
            <select
              id="lws-projectName"
              name="projectName"
              required
              onChange={handleChange}
              value={formState.projectName}
            >
              <option value hidden selected>
                Select Project
              </option>
              <option>Scoreboard</option>
              <option>Flight Booking</option>
              <option>Product Cart</option>
              <option>Book Store</option>
              <option>Blog Application</option>
              <option>Job Finder</option>
            </select>
          </div>
          <div className="fieldContainer">
            <label htmlFor="lws-deadline">Deadline</label>
            <input
              type="date"
              name="deadline"
              id="lws-deadline"
              required
              onChange={handleChange}
              value={formState.deadline}
            />
          </div>
          <div className="text-right">
            <button type="submit" className="lws-submit">
              Save
            </button>
          </div>
        </form>
      </div>
    </main>
  );
}
